console.cclog('CC_CONSTANTS: ', CC_CONSTANTS);
console.cclog('CC_HAS_ACF_PRO: ', CC_CONSTANTS.hasAcfPro);
console.cclog('CC_HAS_ACF_CONFIG_PLUGIN: ', CC_CONSTANTS.hasAcfConfigPlugin);
console.cclog('CC_HAS_EVENTS_CALENDAR: ', CC_CONSTANTS.hasEventsCalendar);
console.cclog('CC_HAS_GRAVITY_FORMS: ', CC_CONSTANTS.hasGravityForms);
console.cclog('CC_ENVIRONMENT: ', CC_CONSTANTS.environment);
console.cclog('CC_IS_PORTABLE: ', CC_CONSTANTS.isPortable);

import 'bootstrap';
import 'sharer.js';
import ready, { HTML } from './utils';
import initSwiper from './components/swiper';
import initAos from './components/aos';
import initMainMenu from './components/mainMenu';
import initHeaderScale from './components/header-scale';
import initExpandCollapse from './components/expandCollapse';
import initVideoControls from './components/video';
import initProgramList from './components/program-list';
import initProgramFilter from './components/program-filter';
import initCopy from './components/copy';
import initTables from './components/table';
import initViewMore from './components/viewMore';
import initAccordionAnchors from './components/accordion-anchor';
import initArticleToc from './components/article-toc';
import initTabs from './components/tabs';
import initQuickSearch from './components/quick-search';
import initGfProgramOfInterest from './components/gf-program-of-interest';
import { initVideoModal } from './components/video';
import menuCollapseHelper from "./components/menuHelper";
import offCanvasAnchorClose from "./components/offcanvas-anchor-close";
import initGfEntryTerm from './components/gf-entry-term';
import initReadMore from './components/read-more';
import initGoogleLogin from './components/google-login';
import ccWireGoogleCSE from './components/wireGoogleCSE';
import initConfetti from './components/confetti';

ready(() => {

  HTML.classList.add('is-loaded');
  HTML.classList.remove('no-js');
  initSwiper();
  initAos();
  initHeaderScale();
  initMainMenu();
  initExpandCollapse();
  initVideoControls();
  initVideoModal();
  initProgramList();
  initProgramFilter();
  initCopy();
  initTables();
  initViewMore();
  initAccordionAnchors();
  initArticleToc();
  initTabs();
  initQuickSearch();
  menuCollapseHelper();
  initReadMore();
  initGoogleLogin();
  initConfetti();
  offCanvasAnchorClose();

  if (CC_CONSTANTS.hasGravityForms) {
    console.cclog('Gravity Forms present, loading gf-program-of-interest');
    initGfProgramOfInterest();
    console.cclog('Gravity Forms present, loading gf-entry-term');
    initGfEntryTerm();
  }
  if (!CC_CONSTANTS.isPortable) {
    console.cclog('Production site, loading ccWireGoogleCSE');
    ccWireGoogleCSE();
  }

  document.addEventListener('keydown', e => {
    if (
      e.key === ' ' &&
      e.target.getAttribute('role') !== null &&
      e.target.getAttribute('role') === 'button') {
      e.preventDefault();
      e.target.click();
    }
  })

});
